export { default as ContainerNavigationNext } from './src/components/container-navigation-next';

// FocusedNavigationNext uses @atlaskit/navigation-next components instead of old AkNav components.
export { default as FocusedNavigationNext } from './src/components/focused-navigation-next';
export {
  default as NavigationNextWithIntl,
  NavigationNext,
} from './src/components/index-next';

export { filterRepositories } from './src/utils/result-filters';

export {
  createNestedMenu,
  findNestedMenuItem,
  mapNestedMenuItems,
  addMenuItemsById,
  ROOT_MENU_ID,
} from './src/utils/create-nested-menu';

export {
  MenuItem,
  ResizeEvent,
  PullRequestGlobalSearchResult,
  RepositoryGlobalSearchResult,
  Site,
  SiteUser,
} from './src/types';

export { default as ConnectMenuItemIcon } from './src/components/connect-menu-item-icon';
export { default as ReposContext } from './src/components/contexts';
export { default as icons } from './src/components/icons-map';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
export {
  UIControllerInterface,
  UIControllerSubscriber,
  withNavigationUIController, // @ts-ignore TODO: fix noImplicitAny error here
} from '@atlaskit/navigation-next';
